<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Пользователи системы

  .container.mt-5
    .white_block
      .row
        .col-sm-1 ID
        .col-sm-2 Имя
        .col-sm-2 Email
        .col-sm-2 Телефон
        .col-sm-1 Франшиза
        .col-sm-2 Создан
        .col-sm-2 Действия
      .row.user(v-for="user in users")
        .col-sm-1 №{{ user.id }}
        .col-sm-2(style="overflow: hidden; text-overflow: ellipsis") {{ user.name }}
        .col-sm-2(style="overflow: hidden; text-overflow: ellipsis") {{ user.email }}
        .col-sm-2 {{ user.phone }}
        .col-sm-1 {{ user.franchise_id }}
        .col-sm-2(style="overflow: hidden; text-overflow: ellipsis") {{ user.created }}
        .col-sm-2.p-0
          a.action(
            @click="loginAs(user.email)",
            href="#",
            title="Войти под пользователем"
          )
            i.fas.fa-sign-in-alt
          router-link.action(
            :to="'/admin/contracts/?user_id=' + user.id",
            title="Посмотреть юридическую информацию и договор"
          )
            i.fas.fa-file-contract
          router-link.action(
            :to="'/admin/transactions/?user_id=' + user.id",
            title="Посмотреть баланс"
          )
            i.fas.fa-wallet
          router-link.action(
            :to="'/admin/addmoney/?user_id=' + user.id",
            title="Начислить бонусы или рубли"
          )
            i.fas.fa-hand-holding-usd
          router-link.action(
            :to="'/admin/change_password/?user_id=' + user.id",
            title="Сменить пароль"
          )
            i.fas.fa-key
</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      users: [],
    };
  },

  computed: {},

  mounted() {
    this.loadUsers();
  },

  methods: {
    async loadUsers() {
      let users = (await apiDriver.admin.users.list()).users;
      for (let u of users) u.created = moment(u.createdAt).format("DD.MM.YYYY");
      this.users = users;
    },
    async loginAs(email) {
      let token = (await apiDriver.admin.users.loginAs(email)).token;
      localStorage.returnAdminToken = localStorage.token;
      localStorage.token = token;
      document.location.href = "/";
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.user {
  &:hover {
    background: #eee;
  }
}

.action {
  padding: 1px 5px;
  border: 1px solid #eee;
  display: inline-block;
  margin-bottom: 1px;
  margin-top: 1px;
  border-radius: 3px;
  margin-right: 2px;
  color: #4e4e4e;

  &:hover {
    color: black;
    border-color: #d0d0d0;
  }
}

@media (prefers-color-scheme: dark) {
  .user {
    &:hover {
      background: #2e2e2e;
    }
  }

  .action {
    border: 1px solid #525252;
    color: #e3e3e3;

    &:hover {
      color: white;
      border-color: #d0d0d0;
    }
  }
}
</style>
